import PropTypes from 'prop-types'
import { memo } from 'react'

import { ActionButtonOverrides, ActionsRow, NoContractPill } from './styled-components'
import { Button } from 'baseui/button'
import { Check } from 'baseui/icon'
import IconCustomZoho from '@/shared/icons/IconCustomZoho'

const ActionRowComponent = ({ row, t }) => {
  if (! row.hasContract) {
    return <NoContractPill>{t('contacts.no_contract')}</NoContractPill>
  }

  return (
    <ActionsRow>
      <Button
        size="compact"
        kind="secondary"
        isLoading={row.isSignNetLoading}
        disabled={row.signNetDisabled}
        title={row.signNetDisabled ? t('contacts.actions.sign_to_net_disabled') : undefined}
        onClick={row.onSignNet}
        overrides={ActionButtonOverrides}
        startEnhancer={() => <Check size={16} />}
      >
        {t('contacts.actions.sign_to_net')}
      </Button>

      <Button
        size="compact"
        kind="secondary"
        isLoading={row.isResyncZohoLoading}
        disabled={row.resyncZohoDisabled}
        title={row.resyncZohoDisabled ? t('contacts.actions.resync_zoho_disabled') : undefined}
        onClick={row.onResyncZoho}
        overrides={ActionButtonOverrides}
        startEnhancer={() => <IconCustomZoho size={16} />}
      >
        {t('contacts.actions.resync_zoho')}
      </Button>
    </ActionsRow>
  )
}

ActionRowComponent.propTypes = {
  row: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
}

export default memo(ActionRowComponent)
